import React, { useState, useEffect } from 'react';
import { Table, Tooltip, message } from 'antd';
import apis from '@/pages/activity-manage/merchants/detail/components/merchant-pool/apis';
import type { ColumnsType } from 'antd/es/table';
import { red } from '@/components/color';

interface IConditions {
  planCode?: string;
  pageSize?: number;
  currentPage?: number;
  type?: string;
}

interface IProps {
  planCode?: string;
  type?: string;
  fileList?: string[];
  sceneCode?: string;
  title: string;
}

interface IData {
  list?: any[];
  totalCount?: number;
  pageSize?: number;
}

interface IColumns {
  key: React.Key;
  fileName: string;
  failCount?: number;
  currProgress?: number;
  fullProgress?: number;
  downloadUrl?: string;
  graded?: string;
  status: number;
  msg?: string;
}

const AddUploadList: React.FC<IProps> = (props) => {
  const { fileList, title, ...resProps } = props;
  const [conditions, setConditions] = useState<IConditions>({ ...resProps });
  const [allData, setAllData] = useState<IData>({});

  useEffect(() => {
    apis.merchantPoolListUploadRule(conditions).then((res) => {
      const { ret, data, msg } = res;
      if (ret && ret === '0') {
        setAllData(data);
      } else {
        message.error(msg);
      }
    });
  }, [conditions, fileList]);

  const columns: ColumnsType<IColumns> = [
    {
      title: '文件名称',
      width: 200,
      dataIndex: 'fileName',
      render(data: string) {
        return (
          <Tooltip className="ellipsis-1-line" title={data}>
            {data}
          </Tooltip>
        );
      },
    },

    {
      title: '上传进度',
      width: 90,
      render(data, record) {
        const { currProgress: curr, fullProgress: full } = record;
        if (record.status === 2) return <span style={{ color: red.primary }}>{record.msg}</span>;
        if (full === 0) return '等待中...';
        if ((curr === 0 || curr) && full && curr !== full) {
          return <span>补录中（完成{((curr / full) * 100).toFixed(0)}%）</span>;
        }

        if (curr === full) {
          return '已完成';
        }

        return '-';
      },
    },
    {
      title: '上传失败数',
      dataIndex: 'failCount',
      width: 90,
      render(data) {
        if (Number(data) > 0) {
          return <span style={{ color: red.primary }}>{data}个</span>;
        }
        return '-';
      },
    },
    {
      title: '操作',
      width: 60,
      render(data, record) {
        return (
          record.downloadUrl && (
            <a
              onClick={() => {
                if (record.downloadUrl) {
                  window.location.href = record.downloadUrl;
                }
              }}
            >
              下载
            </a>
          )
        );
      },
    },
  ];

  return (
    <div className="add-upload-list-wrap global-add-upload-list-wrap">
      <div>
        <span className="fontWeight">
          {title}（{allData.totalCount}）
        </span>
        <span style={{ fontSize: '12px', color: '#979797' }}>
          上传后校验需要时间，请青稍后再次唤起弹窗查看上传的状态
        </span>
      </div>
      <Table
        columns={columns}
        dataSource={allData.list}
        scroll={{ y: 300 }}
        pagination={{
          current: conditions.currentPage,
          total: allData.totalCount,
          pageSize: conditions.pageSize,
          showSizeChanger: false,
          onChange: (toPage, pageSize) => {
            setConditions({
              ...conditions,
              currentPage: toPage,
              pageSize: pageSize,
            });
          },
        }}
      />
    </div>
  );
};

export default AddUploadList;
